import React from 'react';
import SVGLoader from './SVGLoader';

export default ({ width, height, viewboxWidth, viewboxHeight, ...rest }) => {
  return (
    <SVGLoader
      {...rest}
      width={width || 12}
      height={height || 12}
      viewboxWidth={viewboxWidth || 12}
      viewboxHeight={viewboxHeight || 12}
    >
      <g transform="matrix(1.2,0,0,1.2,0,0)">
        <path
          d="M8.03,6.22a.749.749,0,0,0-1.06,0L5.75,7.439V.75a.75.75,0,0,0-1.5,0V7.439L3.03,6.22A.75.75,0,0,0,1.97,7.28l2.5,2.5a.748.748,0,0,0,1.06,0l2.5-2.5A.749.749,0,0,0,8.03,6.22Z"
          fillRule="nonzero"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
      </g>
    </SVGLoader>
  );
};
